import React from "react";
import { useLocation } from "react-router-dom";
import Content from "../../../components/Contents/Content";

const NewsDetail = () => {


  const { state } = useLocation();
  const news = state?.newsData;



  if (!news) {
    return (
      <Content
        Page_title="News Detail"
        button_status={false}
        backbutton_status={true}
        backForword={true}
      >
        <div className="text-center">No news data found.</div>
      </Content>
    );
  }



  return (
    <Content
      Page_title="News Detail"
      button_status={false}
      backbutton_status={true}
      backForword={true}
    >
      <div className="card">
        <div className="card-body">
          <h4 className="text-yellow">{news.title}</h4>

          <div className="row">
            <div className="col-md-6">
              <div className="card-img p-3">
                <img
                  src={news.image}
                  alt="news"
                  className="img-fluid"
                />
              </div>
            </div>
            <div className="col-md-12 mt-3">
              <label><strong>Description:</strong></label>
              <div
                className="form-control"
                style={{
                  minHeight: "80px",
                  resize: "vertical",
                  whiteSpace: "normal",
                  overflowY: "auto"
                }}
                dangerouslySetInnerHTML={{ __html: news.description }}
              />
            </div>
          </div>
        </div>
      </div>
    </Content>
  );
};

export default NewsDetail;
